<div class="krk-details-view-container" *ngIf="krkObject" fxLayout="column" fxLayoutGap="15px" >
  <div class="id-info">
    <mat-form-field appearance="fill" color="accent">
      <mat-label>ID</mat-label>
      <input matInput placeholder="ID" [disabled]="true" [value]="krkObject.recordId?.toString()">
    </mat-form-field>
  </div>

  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + krkObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="krkObject.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).krk.write" (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
    <button [disabled]="!(userPermissions | async).krk.delete" (click)="delete()" mat-stroked-button color="warn"><mat-icon>delete</mat-icon> <span> Usuń</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane KRK</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="Kto ponosi opłatę" [value]="krkObject.payer?.name"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="50" header="Data wyrobienia" [value]="krkObject.activeFrom | date:'y-MM-dd'"></app-detail>
              <app-detail fxFlex="50" header="Data ważności" [value]="krkObject.activeTo | date:'y-MM-dd'"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail-bool fxFlex="50" header="Wyrabiane przez OFWCA" [value]="krkObject.ofwcaRequested"></app-detail-bool>

              <app-detail-bool fxFlex="50"  header="Aktywna opłata" [value]="krkObject.activeFee"></app-detail-bool>
            </div>

          </mat-card>
        </div>
      </div>

    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="100" header="OFWCA" [value]="krkObject.ofwca?.fullName" [link]="['/ofwca/szczegoly', krkObject.ofwca?.uuid]"></app-detail>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane OFWCA</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Nazwisko rodowe" [value]="krkObject.ofwca?.familyName"></app-detail>

              <app-detail fxFlex="50" header="Nazwisko" [value]="krkObject.ofwca?.lastName"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Imię" [value]="krkObject.ofwca?.firstName"></app-detail>

              <app-detail fxFlex="50" header="Drugie imię" [value]="krkObject.ofwca?.secondName"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Imię ojca" [value]="krkObject.ofwca?.fathersName"></app-detail>

              <app-detail fxFlex="50" header="Imię matki" [value]="krkObject.ofwca?.mothersName"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Data urodzenia" [value]="krkObject.ofwca?.birthDate | date:'y-MM-dd'"></app-detail>

              <app-detail fxFlex="50" header="Nazwisko rodowe matki" [value]="krkObject.ofwca?.mothersMaidenName"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Miejsce urodzenia" [value]="krkObject.ofwca?.birthPlace"></app-detail>

              <app-detail fxFlex="50" header="Adres zamieszkania (miasto)" [value]="krkObject.ofwca?.livingAddress?.city"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="PESEL" [value]="krkObject.ofwca?.pesel"></app-detail>

              <app-detail fxFlex="50" header="Obywatelstwo" [value]="krkObject.ofwca?.citizenship"></app-detail>

            </div>

          </mat-card>
        </div>
      </div>

    </div>

  </div>
</div>
